import { TextField as MUITextField, TextFieldProps as MUITextFieldProps } from '@mui/material';
import React from 'react';
import { Controller, FieldError } from 'react-hook-form';
import ReactPhoneInput from 'react-phone-input-mui';

export type PhoneNumberProps = Omit<MUITextFieldProps, 'name'> & {
  name: string;
  parseError?: (error: FieldError) => string;
  defaultCountry?: string;
  disabled?: boolean;
};

const PhoneNumber = React.memo(
  ({ required, parseError, defaultCountry, name, label, disabled, ...rest }: PhoneNumberProps): JSX.Element => (
    <Controller
      name={name}
      render={({ field: { value, onChange }, fieldState: { invalid, error } }) => (
        <ReactPhoneInput
          value={value}
          defaultCountry={defaultCountry || 'ca'}
          onChange={onChange}
          component={MUITextField}
          disabled={disabled ? true : false}
          inputExtraProps={{
            name,
            label: label ? `${label} ${required ? ' *' : ''}` : undefined,
            error: invalid,
            // eslint-disable-next-line no-nested-ternary
            helperText: error ? (typeof parseError === 'function' ? parseError(error as any) : error.message) : rest.helperText,
            ...rest
          }}
        />
      )}
    />
  )
);

export default PhoneNumber;
